import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
// import { MatFormFieldModule } from '@angular/material/form-field-module.d';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { HeaderStyleOneComponent } from 'src/app/components/common/header-style-one/header-style-one.component';
import { MaterialModule } from 'src/app/material.module';
import { Apiservice } from 'src/app/services/apiservice';
import Swal from 'sweetalert2';
declare var RazorpayCheckout: any;
declare var Razorpay: any;
@Component({
  selector: 'app-applycompines',
  imports: [HeaderStyleOneComponent, MatTableModule, MatPaginatorModule, MatFormFieldModule, MatInputModule, MatSortModule, CommonModule, FormsModule, MaterialModule, NgSelectModule, ReactiveFormsModule, HeaderStyleOneComponent],
  templateUrl: './applycompines.html',
  styleUrl: './applycompines.scss'
})
export class Applycompines {
  district_id: any;
  ulb_id: any;
  selectSlf: any;
  districtData: any = [];
  ulbData: any = [];
  slfData: any = [];
  registrationform: FormGroup
  photoPreview: any = null;
  showloader: any;
  companiesList: any = [];
  filteredPositions: any = [];
  userDetails: any;
  melanotifcations: any = [];
  mastermelanotifcations: any = [];
  submittedregist: boolean;
  constructor(private fb: FormBuilder, private api: Apiservice, private acrouter: ActivatedRoute, private router: Router) { }
  ngOnInit(): void {

    this.registrationform = this.fb.group({
      full_name: ['',],
      father_or_husband_name: ['',],
      date_of_birth: ['',],
      gender: ['',],
      contact_number: ['',],
      email: ['',],
      aadhaar_number: ['',],
      address: ['',],
      companyDetails: this.fb.array([this.createcompanyGroup()]),
    });
    this.getProfileData();


    this.acrouter.queryParams.subscribe((res: any) => {
      console.log(res);
      this.getMelaNotifications(res.reqId);
    });

  }
  createcompanyGroup(): FormGroup {
    return this.fb.group({
      company_name: ['', Validators.required],
      position: ['', Validators.required],
      company_id: ['']
    });
  }
  get companyDetails(): FormArray {
    return this.registrationform.get('companyDetails') as FormArray;
  }


  addMorecompanies() {
    this.companyDetails.push(this.createcompanyGroup());
  }
  removecompanies(index: number) {
    this.companyDetails.removeAt(index);
  }
  getUlbData(event) {

  }
  getadminSlfReport(event) {

  }
  getShgTotalReport(event) {

  }
  getMelaNotifications(reqId) {
    this.showloader = true;
    this.api.getMelaNotifications().subscribe((res: any) => {
      if (res.status === 200) {
        this.mastermelanotifcations = res.data;
        this.melanotifcations = res.data.filter(a => a.reqId == reqId);
        console.log(this.melanotifcations);
        this.showloader = false;
        this.getJobslist(this.melanotifcations);
      }
    },
      (err) => {
        this.showloader = false;
        console.error('API error:', err);
      });
  }
  getJobslist(melanotifcations) {
    // console.log(this.jobsArray);
    let obj = {
      mela_id: melanotifcations[0].id
    }
    this.showloader = true;
    this.api.getJobslist(obj).subscribe((res: any) => {
      if (res.status === 200) {
        console.log(res.data);
        res.data.map(((respo, index) => {
          respo.i = index + 1;
        }));
        this.companiesList = res.data;
        this.showloader = false;;
      }
    },
      (err) => {
        this.showloader = false;
        console.error('API error:', err);
      }
    );
  };

  getPositions() {
    let positions = this.companiesList.filter(a => a.company_name)
  }

  onCompanyChange(index: number) {
    const selectedCompany = this.companyDetails.at(index).get('company_name')?.value;
    const company = this.companiesList.filter(c => c.company_name == selectedCompany);
    console.log(company);

    this.companyDetails.at(index).get('company_id')?.setValue(company[0].id);
    this.filteredPositions[index] = company ? company : [];

  }


  getProfileData() {
    this.api.getUserprofileData().subscribe((res: any) => {
      console.log(res);
      this.showloader = false;
      if (res.status == 200) {
        let user = res.data[0];
        this.userDetails = res.data[0];
        console.log(user);
        this.photoPreview = user?.image;
        this.registrationform.patchValue({
          full_name: user?.user_name,
          father_or_husband_name: user?.father_or_husband_name,
          date_of_birth: user?.date_of_birth,
          gender: user?.gender,
          contact_number: user?.phone_number,
          email: user?.email,
          aadhaar_number: user?.aadhaar_number,
          address: user?.address
        });
      }
    }, err => {
      this.showloader = false;
    })
  }



  submitMakePaymentDetails() {
    this.submittedregist = true;
    if (this.registrationform.invalid) {
      return;
    } else {


      console.log(this.melanotifcations);
      this.registrationform.value.user_id = this.userDetails?.id;
      this.registrationform.value.mela_id = this.melanotifcations[0]?.id;
      this.registrationform.value.mela_date = this.melanotifcations[0]?.mela_date;
      this.registrationform.value.district_id = this.melanotifcations[0]?.district_id;
      this.registrationform.value.ulb_id = this.melanotifcations[0]?.ulb_id;
      console.log(this.registrationform.value);
      this.showloader = true;
      this.api.submitJobApplicationDetails(this.registrationform.value).subscribe((res: any) => {
        this.showloader = false;
        if (res.status === 200) {
          console.log(res);
          if (res.orderId != null) {
            var options = {
              description: 'Credits towards consultation',
              image: '',
              currency: 'INR',
              // key: 'rzp_test_lnJctCCH6PgpQ9',
              // secret_key: 'tF2z0Co2HZOWA8MU0JaQSNX6',
              key: 'rzp_live_Rbz0Rya6i4Eqkh',
              secret_key: '0tt245ucIDoexF0scmeVsR3J',
              amount: 100 * 100,
              name: 'MEPMA-NIPUNA JOB MELA',
              order_id: res.orderId.id,
              prefill: {

                contact: this.registrationform.value.contact_number,
                name: this.registrationform.value.full_name,
              },
              theme: {
                color: '#d3262b'
              },
              handler: (response) => {
                // ✅ This is where you get payment success response
                console.log('Payment successful', response);

                const obj = {
                  mela_id: this.registrationform.value.mela_id,
                  user_id: this.registrationform.value.user_id,
                  order_id: res.orderId.id,
                  payment_id: response.razorpay_payment_id
                };

                this.api.updatePaymetStatus(obj).subscribe((res: any) => {
                  this.registrationform.reset();
                  this.photoPreview = null;
                  Swal.fire({
                    icon: 'success',
                    title: 'Submitted Successfully',
                    text: 'Your details have been submitted successfully.',
                    confirmButtonText: 'OK'
                  });
                  this.router.navigate(['/'], { replaceUrl: true });
                });
              },
              modal: {
                ondismiss: () => {
                  alert('Payment cancelled');
                }
              }
            };
            var rzp1 = new Razorpay(options);
            rzp1.open();
          }


        } else if (res.status === 409) {
          Swal.fire({
            icon: 'warning',
            title: 'Already Submitted',
            text: 'You have already Submitted.',
            confirmButtonText: 'Ok'
          }).then(() => {
            this.router.navigate(['/profile'], { replaceUrl: true });
          });
        } else if (res.status === 405) {
          Swal.fire({
            icon: 'error',
            title: 'Invalid OTP',
            text: 'The OTP you entered is incorrect. Please try again.',
            confirmButtonText: 'Retry'
          });
        }
        else {
          Swal.fire({
            icon: 'warning',
            title: 'Submission Failed',
            text: res.message || 'Something went wrong.',
            confirmButtonText: 'Retry'
          });
        }
      },
        (err) => {
          if (err.status === 409) {
            Swal.fire({
              icon: 'warning',
              title: 'Already Submitted',
              text: 'You have already Submitted.',
              confirmButtonText: 'Ok'
            }).then(() => {
              this.router.navigate(['/'], { replaceUrl: true });
            });
          } else if (err.status === 405) {
            Swal.fire({
              icon: 'error',
              title: 'Invalid OTP',
              text: 'The OTP you entered is incorrect. Please try again.',
              confirmButtonText: 'Retry'
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Something went wrong. Please try again later.'
            });
          }
          this.showloader = false;
          console.error('API error:', err);
        });
    }

  }


  onImageChange(e: any) {
    console.log(e);
    const reader = new FileReader();
    if (e.target.files && e.target.files.length) {
      const [file] = e.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.photoPreview = reader.result;
        var imgFile = reader.result as string;
        console.log(e.target.files[0].name);
        var bfile_typeEmpl = e.target.files[0].name.split('.');
        console.log("bfile: ", bfile_typeEmpl);
        var imgtype = bfile_typeEmpl[bfile_typeEmpl.length - 1];
        console.log(imgtype);
        // this.imageData.push({ reviewimg: imgFile, filetype: imgtype });
        // console.log("image data", this.imageData, this.imageData[0].filetype);
      };
    }
  }
}
